import { useEffect } from 'react';
import * as THREE from 'three';

export default function Favicon3D() {
  useEffect(() => {
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;

    const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true });
    renderer.setSize(64, 64);
    renderer.setPixelRatio(1);
    renderer.setClearColor(0x000000, 0);

    const scene = new THREE.Scene();
    const frustum = 1.4;
    const camera = new THREE.OrthographicCamera(-frustum, frustum, frustum, -frustum, 0.1, 100);
    camera.position.set(0, 0.3, 4);
    camera.lookAt(0, 0, 0);

    scene.add(new THREE.AmbientLight(0xffffff, 0.5));
    const dir = new THREE.DirectionalLight(0xffffff, 1.2);
    dir.position.set(3, 5, 3);
    scene.add(dir);

    const mesh = new THREE.Mesh(
      new THREE.BoxGeometry(1.8, 1.8, 1.8),
      new THREE.MeshStandardMaterial({ color: 0x888888, metalness: 0.3, roughness: 0.4 })
    );
    scene.add(mesh);

    // Get or create the favicon link element
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    let animId;
    let lastUpdate = 0;
    const INTERVAL = 1000 / 24; // ~24fps for favicon

    const animate = (timestamp) => {
      animId = requestAnimationFrame(animate);
      mesh.rotation.y += 0.015;
      mesh.rotation.x += 0.004;
      if (timestamp - lastUpdate >= INTERVAL) {
        lastUpdate = timestamp;
        renderer.render(scene, camera);
        link.href = canvas.toDataURL('image/png');
      }
    };
    animId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animId);
      renderer.dispose();
    };
  }, []);

  return null;
}
